module.exports = __webpack_public_path__ + "img/family-11.b337aeed.jpg";